import React from 'react';

import { NamedRedirect } from '../../../components';
import { listingPageLinkProps } from '../../../util/listingSeoUrl';

import css from './ListingNumberMatch.module.css';

/**
 * The public search text was a listing number (P25009-512 BR-7).
 *
 *   one listing has it    → open that listing. A redirect, so it also works on
 *                           a shared link or a reload: the server render turns
 *                           it into an HTTP redirect (C-7) and the browser
 *                           replaces the search in its history.
 *   several have it       → the results are exactly those, and this line names
 *                           each seller, because two sellers can share a number
 *                           (BR-10) and the caller has to pick theirs.
 *
 * Renders nothing for any other search.
 */
const ListingNumberMatch = ({ match, listings }) => {
  if (!match) return null;

  if (match.redirectListingId) {
    const listing = (listings || []).find(l => l?.id?.uuid === match.redirectListingId);
    return listing ? <NamedRedirect {...listingPageLinkProps(listing)} /> : null;
  }

  const matches = (listings || []).filter(l => match.listingIds.includes(l?.id?.uuid));
  if (matches.length < 2) return null;
  /* One name per seller ACCOUNT, not per name: two accounts can carry the same
   * display name — and then the same prefix, so the same number. On Test,
   * WP-MI00007 belongs to two different "Mindset" accounts. */
  const sellerNames = new Map();
  matches.forEach(l => {
    const sellerId = l?.author?.id?.uuid;
    const name = l?.author?.attributes?.profile?.displayName;
    if (sellerId && name && !sellerNames.has(sellerId)) sellerNames.set(sellerId, name);
  });
  const names = [...sellerNames.values()];
  const sellersText =
    names.length > 1
      ? `Från ${names.length} olika säljare: ${names.join(', ')}.`
      : names.length === 1
      ? `Säljare: ${names[0]}.`
      : null;

  return (
    <div className={css.root} role="status">
      <p className={css.text}>
        <strong>
          {matches.length} annonser har annonsnummer {match.tireId}.
        </strong>{' '}
        {sellersText}
      </p>
    </div>
  );
};

export default ListingNumberMatch;
